import { useUserAgent } from '@oieduardorabelo/use-user-agent'

export const useIsMobile = () => {
	const agent = useUserAgent()

	return agent?.device?.type === 'mobile'
}
